import { ThemeProvider, createTheme } from '@mui/material/styles';
import React from 'react';


import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements,  } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import { Container } from "@mui/material";

import Connexion from "./pages/Connexion";
import Shipments from "./pages/Shipments";
import ShipmentDetails from "./pages/ShipmentDetails";
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import Logs from './pages/Logs';
import Monitor from './pages/Monitor';

import { MenuTop } from './components/MenuTop'

import { AuthProvider } from './hoc/AuthProvider';
import { RequireAuth } from './hoc/RequireAuth';
import { FilterProvider } from './hoc/FilterProvider'


import './static/style.module.css'

function App() {

    const darkTheme = createTheme({
        palette: {
            background: {
                default: "#f7f6f6"
              },
        components: {
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        "&:last-child": { padding: '10px 10px 30px 10px', },
                    },
                },
            },
        }}
    });

    const router = createBrowserRouter(createRoutesFromElements(
        <>
            <Route path="/connexion" element={<Connexion />} />
            <Route path="/" element={<MenuTop />} >
                <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
                <Route path="/orders" element={<RequireAuth><Orders /></RequireAuth>} />
                <Route path="/orders/:id" element={<RequireAuth><OrderDetails /></RequireAuth>} />
                <Route path="/shipments" element={<RequireAuth><Shipments /></RequireAuth>} />
                <Route path="/shipments/:shipmentID" element={<RequireAuth><ShipmentDetails /></RequireAuth>} />
                <Route path="/logs" element={<RequireAuth><Logs /></RequireAuth>} />
                <Route path="/monitor" element={<RequireAuth><Monitor /></RequireAuth>} />
            </Route>

        </>

    ))

    return (
        <React.StrictMode>
            <AuthProvider>
                <FilterProvider>
                    <ThemeProvider theme={darkTheme}>
                        <CssBaseline />
                        <Container className="App" >
                            <RouterProvider router={router} />
                        </Container>
                    </ThemeProvider>
                </FilterProvider>
            </AuthProvider>

        </React.StrictMode>
    )
}

export default App;
